import { useDocumentTitle } from '@mantine/hooks';

/**
 * Hook to set the page title with a "Phono | " prefix.
 * Wraps @mantine/hooks useDocumentTitle to automatically prefix all titles.
 * @param title - The page title (will be displayed as "Phono | {title}")
 */
export function useTitle(title?: string): void {
  useDocumentTitle(title || 'Phono');
}

